import HomeBanner from "../../assets/home-banner.png";
import config from "../../config.js";

import 'flowbite';
import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet";
import { OptimizeSEO } from "../../components/OptimizeSEO";
import {
  SECTION_ONE_HEADING,
  SECTION_ONE_SUBHEADING,
} from '../../constants/HomePageConstants';
import { seoContent } from "../../constants/SEOConstant";
import { FAQSection } from "./FAQSection";
import StackedCards from "./StackedCards";
import { SupportedApps } from "./SupportedApps";

export default function HomePage() {
  return (
    <>
      <OptimizeSEO {...seoContent.home} />
      {/* Start block */}
      <section className="bg-gray-50 dark:bg-zinc-950 py-8 sm:py-8">
        <div className="grid max-w-screen-xl px-4 pt-20 pb-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12 lg:pt-28">
          <div className="mr-auto place-self-center lg:col-span-7 text-center sm:text-left">
            <h1 className="max-w-2xl mb-4 text-3xl text-gray-900 font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white">
              {SECTION_ONE_HEADING}
            </h1>
            {/* <p className="font-semibold mt-3 mb-6 dark:text-white">Keep your music. Change your platform. Stay in sync.</p> */}
            <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
              {SECTION_ONE_SUBHEADING}
            </p>
            <div className="space-y-4 sm:flex sm:space-y-0 sm:space-x-4">
              <Link
                to="/login"
                className="inline-flex items-center justify-center w-full px-5 py-3 text-sm font-medium text-center text-white bg-purple-700 border border-transparent rounded-lg sm:w-auto hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
                style={{ marginBottom: '20px' }}
              >
                Start Transferring Free
              </Link>
            </div>
          </div>
          <div className="lg:mt-0 lg:col-span-5 lg:flex">
            <img src={HomeBanner} alt="Transfer playlists" style={{ borderRadius: '2%' }} />
          </div>
        </div>
      </section>
      {/* End block */}
      <SupportedApps />
      <StackedCards/>
      {/* <TransferVisualizer/> */}
      <FAQSection />
      <section className="bg-gray-50 dark:bg-zinc-800">
        <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6">
          <div className="max-w-screen-sm mx-auto text-center">
            <h2 className="mb-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">
              Start your transfer for free
            </h2>
            <p className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">
            </p>
            <a
              href={config.signupPath}
              className="text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 focus:outline-none dark:focus:ring-purple-800"
            >
              Sign up
            </a>
          </div>
        </div>
      </section>
    </>
  )
}